import _export from '../internals/export.js';
import stringTrim from '../internals/string-trim.js';
import stringTrimForced from '../internals/string-trim-forced.js';

var $ = _export;
var $trimEnd = stringTrim.end;
var forcedStringTrimMethod = stringTrimForced;
var FORCED = forcedStringTrimMethod('trimEnd');
var trimEnd = FORCED ? function trimEnd() {
  return $trimEnd(this); // eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
} : ''.trimEnd; // `String.prototype.{ trimEnd, trimRight }` methods
// https://tc39.es/ecma262/#sec-string.prototype.trimend
// https://tc39.es/ecma262/#String.prototype.trimright

$({
  target: 'String',
  proto: true,
  name: 'trimEnd',
  forced: FORCED
}, {
  trimEnd: trimEnd,
  trimRight: trimEnd
});
